import { render, staticRenderFns } from "./form-lessonplan.vue?vue&type=template&id=52f556b1&"
import script from "./form-lessonplan.vue?vue&type=script&lang=js&"
export * from "./form-lessonplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports